export interface Testimonial {
  initials: string
  quote: string
  name: string
  role: string
  location: string
}

/** Three short quotes used high on the page as fast social proof. */
export const quickTestimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      "I planned my entire teaching year in one evening. Now every lesson has a clear objective, and my students can't wait to step into class.",
    name: 'Julian R.',
    role: 'Jazz Educator',
    location: 'London',
  },
  {
    initials: 'MS',
    quote:
      "I no longer spend evenings searching for exercises online. I open Jazz Teacher's Arsenal and find everything: organized, ready, and professional. Worth 10 times the price.",
    name: 'Mark S.',
    role: 'Private Studio Owner',
    location: 'Austin',
  },
  {
    initials: 'ST',
    quote:
      'My students improve 3x faster because they finally follow a logical progression. This changed how I teach jazz.',
    name: 'Sophie T.',
    role: 'Music School Director',
    location: 'Melbourne',
  },
]

/** Full wall of reviews further down the page. */
export const testimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      "I planned my entire year in one evening. Every lesson now has a clear objective. My students can't wait to get into the studio. This changed everything.",
    name: 'Julian R.',
    role: 'Jazz Faculty Educator',
    location: 'London',
  },
  {
    initials: 'MS',
    quote:
      'Two months in and my students have made more visible progress than in the entire previous year. The progression is genuinely effective.',
    name: 'Mark S.',
    role: 'Private Studio Owner',
    location: 'Austin',
  },
  {
    initials: 'ST',
    quote:
      "Before I was spending hours online looking for ideas. Now I open Jazz Teacher's Arsenal and everything is there — organized, ready, professional.",
    name: 'Sophie T.',
    role: 'Music School Director',
    location: 'Melbourne',
  },
  {
    initials: 'JF',
    quote:
      'The assessment templates changed how I communicate with parents. Now I can show concrete, measurable progress.',
    name: 'Julia F.',
    role: 'Program Coordinator',
    location: 'Toronto',
  },
  {
    initials: 'AS',
    quote:
      'As a new teacher I was completely overwhelmed. This system gave me professional confidence from day one.',
    name: 'Anna S.',
    role: 'Jazz Educator',
    location: 'Sydney',
  },
]
